import { palette, setColorWithOpacity } from 'src/styles/colors';
import styled from 'styled-components';

export const ImageSlideTextBlockContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  row-gap: 1rem;
  transform-origin: top center;
  transition: transform 300ms ease-in-out;
  cursor: pointer;

  .title-heading {
    max-width: 320px;
    margin-right: auto;
  }

  @media (hover: hover) {
    &:hover,
    &:active {
      transform: scale(1.05);
    }
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  position: relative;
  height: 3px;
  background-color: ${setColorWithOpacity('greyText', 0.2)};
`;

export const ProgressBarFilled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: ${palette.accentBlue};
  width: 0%;
  transition: width ease-in-out;
`;
